<template>
	<div class="processedOrder_Box">
		<div class="title">{{$t('processed.Processedorder')}}</div>
		<div class="block">
		    <span class="demonstration">{{$t('processed.optiondate')}}：</span>
		    <el-date-picker
			size="medium"
		      v-model="value9"
		      type="daterange"
			  @change="getValue()"
			  value-format="yyyy-MM-dd"
		      :start-placeholder="$t('processed.startdate')"
		      :end-placeholder="$t('processed.dateclosed')"
		      >
		    </el-date-picker>
		</div>
		<div class="conditonBox">
			<div style="display: flex;"  v-for="(item,index01) in buttonList" :key="index01">
				<div class="desc">{{item.desc}}</div>
				<span class="filterbox" >
					<span class="storeBox"  :class="{'ttpactive': activeIndex[index01] == ttp.label }" @click="handle(ttp.label,index01,index,ttp.value)"   v-for="(ttp,index) in item.value" :key="index">
						{{ttp.label}} 
					</span>
					
				</span>
			</div>
		</div>

		<div class="block_btn">
			<div>{{amountListCount}}{{$t('other.a707')}}</div>
			<div class="block_btn">
				<div class="scan_btn"><el-button size="medium" type="primary" @click="gotopackage()">{{$t('processed.Warehouse')}}</el-button></div>
				{{$t('processed.ordernumber')}}：
				<el-input
				style="width: 300px;margin-right:30px"
				size="medium"
				:placeholder="$t('processed.Findnumber')"
				@change="searchOrders()"
				clearable
				v-model="dataParams.orderId">
				</el-input>
				
			</div>
			
			</div>
			<div  >
				 <el-table
				      :data="amountList"
					  border
				      style="width: 100%;margin-bottom: 50px;">
				      <el-table-column
				        prop="packagedTime"
				        :label="$t('processed.Dateofpackaging')"
				        >
				      </el-table-column>
				      <el-table-column
				        prop="amount"
				        :label="$t('processed.Quantity')">
				      </el-table-column>
					  <el-table-column
					    prop="cancelAmount"
					    :label="$t('processed.Numberof')">
					  </el-table-column>
					  <el-table-column
					    prop="shippedAmount"
					    :label="$t('processed.Expresscollection')">
					  </el-table-column>
					  <el-table-column
					    prop="escrowAmount"
					    :label="$t('processed.money')">
						<template slot-scope="scope">
							<span>{{scope.row.escrowAmount.toFixed(2)}}</span>
						</template>
					  </el-table-column>
					  <el-table-column
					    prop="escrowAmount"
					    :label="$t('other.a906')">
						<template slot-scope="scope">
							<span>{{scope.row.totalShippedAmount}}</span>
							
						</template>
					  </el-table-column>
					  <!-- <el-table-column
					    prop="escrowAmount"
					    :label="$t('processed.deliveryfee')">
						<template slot-scope="scope">
							<span>{{scope.row.feeAmount.toFixed(2)}}</span>
						</template>
					  </el-table-column> -->
					 <el-table-column
					   :label="$t('processed.operation')"
					   width="400"
					   >
					   <template slot-scope="scope">
					   	 <el-button size="mini" type="primary" @click="viesDetail(scope.row)">{{$t('processed.ViewOrder')}}</el-button>
						 <el-button size="mini"  @click="exportXLMS(scope.row)">{{$t('processed.Exportorders')}}</el-button>
						  <el-button size="mini"  @click="pintTrakingOrder(scope.row)">{{$t('processed.Print')}}</el-button>
					   </template>
					 </el-table-column>
				    </el-table>
				
			</div>
			
				
			<div class="Pager">
				<el-pagination
				style="background-color: #fff;"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage1"
				:page-sizes="[15, 20, 30, 50]"
				:page-size="dataParams.offset"
				layout=" total,sizes, prev, pager, next, jumper"
				:total="amountListCount">
				</el-pagination>
			</div>
		
	</div>
</template>

<script>
		import {mapState, mapActions , mapMutations} from 'vuex'
		import api from '../../../api/moudles/processed.js'
		import newOrderApi from '../../../api/moudles/newOrders.js'
		import utils from '../../../utils/utils.js'
	export default{
		data(){
			return {
				value9: [],
				dataParams:{
					orderId:null,
				},
				allStoreIds:JSON.parse(localStorage.getItem('userInfo')).storeIds,
				allshopIds:JSON.parse(localStorage.getItem('userInfo')).shopIds,
				amountList:[],
				amountListCount:0,
				buttonList:[],
				currentPage1:1,
				activeIndex:[this.$t('other.a358'),this.$t('other.a358'),this.$t('other.a358'),this.$t('other.a358')],
				shopInfo:null,
				userPos:JSON.parse(localStorage.getItem('userInfo')).userPos,
				
			}
		},
		computed:{
			...mapState({
				userId: state=>state.login.userInfo.userId || '',
				falg:state=>state.processed.falg ,
				tableList: state=>state.processed.tableList ,
			}),
			
			dateInfo(){
				let list=JSON.parse(JSON.stringify(this.value9))
				list[1]=utils.CurdateAddoneday(list[1])
				return list
			}
			
			
			
		
		},
		watch:{
			falg(){
				if(this.falg){
					utils.cleanStorageData()
					let obj={
						list:this.tableList,
						shopInfo:this.shopInfo
					}
					localStorage.setItem('tableList',JSON.stringify(obj))
					
					let router = this.$router.resolve(
					  { 
					    name: "processedDetail" ,
					  }
					);
					window.open(router.href, '_blank');
				}
			},
		},
		created(){
			this.getBtn()
			this.init()
		},
		methods:{
			...mapActions('processed',[
				'getProcessedOrderSn',
				'getProcessedOrderInfo',
				'getIDacountProcessedList',
				'getPackagedOrderByStore',//仓库帐号下猎取已出库出库的订单
				'setPackaged',
				'getProcessedOrders',
				'getProcessedOrdersByStore',
				'getLogisticsBystore',
				'getLogisticsByseller',
				'getProcessedOrderBySeller',
				'getProcessedOrderByStore',
				'getOrderByOrderId'
			]),
			
			...mapActions('print',[
			   'getParams',
			   'getAllOrders',
			   'getStoreOrders',
						   
			]),
		
			
			...mapMutations('processed',[
				'SET_PROCESSED_ORDER_LIST',
				'SET_INTN'
			]),

			gotopackage(){
				let shopeePlatform=true
				localStorage.setItem('shopee',JSON.stringify(shopeePlatform))
				let router = this.$router.resolve(
				  { 
				    name: "package" ,
				  }
				)
				
				window.open(router.href, '_blank');
			},

			viesDetail(params){
				console.log(params)
				console.log(this.dataParams)

				let router = this.$router.resolve(
					{ 
					name: "processedDetail" ,
					query:{
						packageTime:params.packagedTime,
						dataParams:JSON.stringify(this.dataParams)

					}
					}
				);
				window.open(router.href, '_blank')
				
			},

			handle(key,index,indexone,value){
				console.log(key,index,indexone)
				this.$set(this.activeIndex,index,key)
				this.dataParams.packageTime=null
				if(index == 0){
					this.dataParams.platform=key == this.$t('other.a358') ? null : value
				}
				if(index == 1){
					this.dataParams.storeIds=key == this.$t('other.a358') ? this.allStoreIds :[value]
				}

				if(index == 2) {
					console.log(value)
					this.dataParams.shopIds=key == this.$t('other.a358') ? this.allshopIds :value
					this.dataParams.sellerId=this.buttonList[index].value[indexone].userId
				}

				if(index == 3){
					this.dataParams.logistics=key == this.$t('other.a358') ? null :key 
					
				}

				this.getPackAgeOrders(this.dataParams)
				console.log(this.dataParams)
				console.log(this.buttonList)
				
			},
			
			getBtn(){
				this.buttonList=[{
					id:0,
					desc:this.$t("processed.Platformtype"),
					value:[{
						label:'SHOPEE',
						value:'SHOPEE'
					},{
						label:'LAZADA',
						value:'LAZADA'
					},{
						label:'TIKTOK',
						value:'TIKTOK'
					},{
						label:this.$t("processed.single"),
						value:'DXS'
					}],
				},{
					id:0,
					desc:this.$t("processed.Select"),
					value:JSON.parse(localStorage.getItem('userInfo')).stores.map(p => {
						return {
							label:p.storeName,
							value:p.storeId
						}
					}),
				},
				{
					id:2,
					desc:this.$t("processed.Typofseller"),
					value:JSON.parse(localStorage.getItem('userInfo')).sellers.map(p => {
						return {
							label:p.userName,
							value:p.shopIds,
							userId:p.userId

						}
					}),
				},{
					id:3,
					desc:this.$t("processed.Logisticstype"),
					value:[],
				}]
				
				this.buttonList.forEach(p => {
					p.value.unshift({
						label:this.$t("processed.all"),
						value:'all'
					})
				})

				
				
				console.log('btn',this.buttonList)
			},
			
			
			init(){
				this.value9=[utils.getRecentSevenDay(-7),utils.getRecentSevenDay(1)]
				
				this.dataParams.end=this.dateInfo[1]
				this.dataParams.start=this.dateInfo[0]
				this.dataParams.storeIds=this.allStoreIds
				this.dataParams.shopIds=this.allshopIds 
				this.dataParams.userId=this.userId 
				this.dataParams.packageTime=null 
				this.dataParams.orderId=null
				this.dataParams.platform=null
				this.dataParams.offset=50
				this.dataParams.page=0
				this.dataParams.orderId=''
				this.dataParams.logistics=null
				console.log(this.dataParams)
				this.getLogisticData(this.dataParams)
				this.getPackAgeOrders(this.dataParams)
				
				
			},

			getValue(){
				this.dataParams.start=this.dateInfo[0]
				this.dataParams.end=this.dateInfo[1]
				this.getLogisticData(this.dataParams)
				this.getPackAgeOrders(this.dataParams)
				
				
			},
			
			getLogisticData(params){
				newOrderApi
				.getLogistics(params)
				.then(res => {
					if(res.code === 200) {
						console.log('res',res.data)
						this.buttonList[3].value=res.data.map(p => {
							return {
								label:p.logistics ? p.logistics : this.$t('other.a907'),
								value:p.logistics
							}
						})

						this.buttonList[3].value.unshift({
							label:this.$t("processed.all"),
							value:'all'
						})

						console.log('btn',this.buttonList)
					}else{
						this.$message.$message.warning(res.msg)
					}
				})
			},

			searchOrders(){
				let parms=JSON.parse(JSON.stringify(this.dataParams))
				if(!parms.orderId){
					parms.packageTime=null
					console.log('12341')
				}else{
					console.log(this.dataParams)
					parms.orderId=parms.orderId.trim()
					
				}

				this.getPackAgeOrders(parms)
			},
			
			getPackAgeOrders(params){
				this.showLoading()
				newOrderApi
				.getPackagedOrdernum(params)
				.then(res => {
					if(res.code === 200) {
						console.log(this.$t("processed.Processedorder"),res.data)
						this.amountList=res.data.orders
						this.amountListCount=res.data.count
					}else{
						this.$message.warning(res.msg)
					}
				})
			},
			
			
			
			
			
			
			
			
		
			
			
			getOrderSn(){
				this.getProcessedOrders(this.req_params)
			},
			
			
			gotopackage(){
				let shopeePlatform=true
				localStorage.setItem('shopee',JSON.stringify(shopeePlatform))
				let router = this.$router.resolve(
				  { 
				    name: "package" ,
				  }
				);
				
				window.open(router.href, '_blank');
			},
			
			
			exportXLMS(params){
				console.log(this.dataParams)
				console.log(params)
				let platform=this.dataParams.platform
				console.log('platform',platform)
				//是否是店小生的自建单
				if(platform == 'DXS'){
					api
					.getProcessedOrderBySeller(this.dataParams)
					.then(res => {
					if(res.code === 200 ){
					console.log('desc',res.data)	
					let orderData=res.data
					let orderIdList=res.data.map(p => {return {orderId:p.orderId}})
					new Promise((resolve) => {
						let ttp=[]
						for(let i=0;i<orderIdList.length;i++ ){
							newOrderApi
							.queryLogisticsOrder(orderIdList[i])
							.then(res => {
							if(res.code === 200 ){
							console.log('desc',res.data)
							ttp.push(res.data)
							if(ttp.length == orderIdList.length){

								resolve(ttp)
							}
							}else{
							this.$message.warning(res.msg)
							}
							})
						}
					}).then(res => {
						console.log('res',res)
						if(res.length > 0){
							let arr=[]
							let list=res
							orderData.forEach(p => {
								let obj=list.find(item =>  item.orderId == p.orderId)
								p.sku=''
								p.items.forEach(k => {
									if(k.storeItem && k.storeItem.component ){//单品
										p.sku+='sku1:' + k.storeItem.skuName  + ' */Qty:' + k.variationQuantityPurchased
									}else{//套餐
										if(k.storeItem && k.storeItem.children){
											k.storeItem.children.forEach((j,ttb )=> {
												let vdf=ttb+1
												p.sku+='sku'+ vdf + '('+ j.cusCode +')' + ':' +j.skuName  + ' */Qty:' + k.variationQuantityPurchased *j.rate
											})
										}
									}
								})
								p.newObj=obj
								arr.push({
								'订单号':p.orderId,
								'运单号':p.trackingNo,
								'产品详情':p.sku,
								'收货人':p.address.name,
								'电话号码':p.address.phone,
								'详细地址':p.address.state + '/' + p.address.city + '/' +p.address.fullAddress,
								'配送方式':p.newObj.logisticsRule ? p.newObj.logisticsRule.logisticsName : null,
								'首重(kg)':p.newObj.logisticsRule ? p.newObj.logisticsRule.firstWeight : null,
								'首重费用(rmb/kg)':p.newObj.logisticsRule ? p.newObj.logisticsRule.firstFee : null,
								'续重费用(rmb/kg)':p.newObj.logisticsRule ? p.newObj.logisticsRule.weightFee : null,
								'实际重量(kg)':p.newObj.weight,
								'实际体积(cm)':p.newObj.width * p.newObj.height * p.newObj.length,
								'实际积分扣费':p.newObj.paidIntegral,
								'下单时间':utils.renderTime(p.createTime),
							})
							})

							console.log('arr',arr)
							let list2=['订单号','运单号','产品详情','收货人','电话号码','详细地址','配送方式','首重(kg)','首重费用(rmb/kg)','续重费用(rmb/kg)','实际重量(kg)','实际体积(cm)','实际积分扣费','下单时间']
							console.log('arr',arr)
							utils.exPortEXml(arr,list2,list2)
							

						}
						console.log('orderData',orderData)
					})
					}else{
					this.$message.warning(res.msg)
					}
					})
				}else{
					
					this.dataParams.packageTime=params.packagedTime
					api
					.getProcessedOrderBySeller(this.dataParams)
					.then(res => {
						if (res.code === 200) {
							console.log('卖家获取所有已处理的订单',res.data)
	
							let arr=[]
			
					console.log(this.targetList)
					res.data.forEach(p => {
						p.items.forEach((k,index) => {
							k.totalSku=''
							k.totalQty=0
							let num=index+1
							if(k.storeItem && k.storeItem.component ){//单品
								k.totalSku='sku1'+':' +k.storeItem.skuName  + ' */Qty:' + k.variationQuantityPurchased
								k.totalQty=k.variationQuantityPurchased
							}else{//套餐
								if(k.storeItem && k.storeItem.children){
									k.storeItem.children.forEach((j,ttb )=> {
										let vdf=ttb+1
										k.totalSku+='sku'+ vdf + '('+ j.cusCode +')' + ':' +j.skuName  + ' */Qty:' + k.variationQuantityPurchased *j.rate
										k.totalQty+=j.rate*k.variationQuantityPurchased
									})
								}
							}
	
							arr.push({
								'订单号':p.orderId,
								'运单号':p.trackingNo,
								'收货人':p.address.name,
								'电话号码':p.address.phone,
								'详细地址':p.address.state + '/' + p.address.city + '/' +p.address.fullAddress,
								'产品名称':k.itemName,
								'单品或套餐':k.storeItem ? k.storeItem.component ? this.$t('other.a251')+k.storeItem.cusCode : this.$t('other.a252') + k.storeItem.cusCode : this.$t('other.a568'),
								'sku详情':k.totalSku,
								'sku数量':k.storeItem ? k.storeItem.component ? 1 : k.storeItem.children.length  : this.$t('other.a568'),
								'购买总数':k.totalQty,
								'实收':k.price,
								'配送方式':p.logistics,
								'下单时间':utils.renderTime(p.createTime),
							})
						})
					})
	
					let list=['订单号','运单号','收货人','电话号码','详细地址','产品名称','单品或套餐','sku详情','sku数量','购买总数','实收','配送方式','下单时间']
					console.log('arr',arr)
					utils.exPortEXml(arr,list,list)
					
						}
					})
				}
			},
			pintTrakingOrder(params){
				let ccp=this.dataParams
				ccp.packageTime=params.packagedTime
				const {href}=this.$router.resolve({
					name:'signOrder',
					query:{
						params:JSON.stringify(ccp)
					}
				
				}) 
				window.open(href)
			},
			
			
			
			//扫描枪调用的方法
			packBageOut(){
				if(this.scanNum){
					this.setPackaged({orderId:this.scanNum})
				}else{
					
					return
				}
			},
			
			
			

			
			handleSizeChange(val) {
				this.dataParams.offset=Number(`${val}`)
				this.getPackAgeOrders(this.dataParams)
			 },
			handleCurrentChange(val) {
			
				this.dataParams.page=this.dataParams.offset*(Number(`${val}`) -1)
				this.getPackAgeOrders(this.dataParams)
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	.processedOrder_Box{

		.title{
			font-size: 18px;
			font-weight: bold;
			margin: 10px 0 20px 0;
		}

		.conditonBox{
			margin-top: 20px;
		}

		
		
		
		.storeBox{
			cursor: pointer;
			display:inline-block;
			margin-bottom:3px;
			padding:4px 11px;
			margin:0 5px 10px 5px;
			min-width:80px;
			text-align: center;
			border-radius: 3px;
			color: #919099;
			border: 1px solid #eee;
			
		}

		.block_btn{
			display: flex;
			align-items: center;
			justify-content: space-between ;
			margin-bottom: 15px;

			.scan_btn{
				margin-right: 20px;
			}

		}


		.Pager{
			position: fixed;
			bottom: 0;
			left: 202px;
			right: 0;
			height: 40px;
			line-height: 40px;
			background-color: #fff;
			text-align:right;
		}

		.ttpactive{
			background-color: #1890ff;
			color: #fff;
		}
	    .ttpactive:hover{
			background-color: #40a9ff;
			color: #fff;
		}
		
	
		
		.desc{
			min-width:80px
		}
		
		
	}
	

	
	
	
</style>
